export default "__VITE_ASSET__z5k94mCP__"